import { Col, Container, Row } from "react-bootstrap";
import contactImg from '../assets/img/contact-img.svg'


export const Contact =() => { 
    
        return(

            <section className="contact" id="contact">
                <Container>
                    <Row className="alignt-items-center">
                        <Col md={6}>
                            <img src={contactImg} alt="contact" />
                        </Col>
                        <Col>
                        <h2>Contact me!</h2>
                        <form action="https://formsubmit.co/marianoveronsantos@gmail.com" method="POST">
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input type="text" name="name" placeholder="First Name" required />
                                    </Col>
                                <Col sm={6} className="px-1">
                                <input type="text" placeholder="Last Name" name="lastName" required />
                                </Col>
                                <Col sm={6} className="px-1">
                                <input type="email" name="email"  placeholder="Email Adress"  required />
                                </Col>
                                <Col sm={6} className="px-1">
                                <input type="number"   placeholder="Phone Number" name="tel" required /> 
                                </Col>
                                <Col>
                                    <textarea row="6" placeholder="Message" name="message" required />
                                </Col> 
                                <Col>
                                <button type="submit"><span>Submit</span></button>
                                </Col>
                               
                            </Row>
                        </form>
                        </Col>
                    </Row>
                </Container>
            </section>
        )}